<template>
    <div class="notification-panel d-flex flex-column h-100">
        <div class="d-flex justify-content-between pb16 border-b gap-3">
            <CustomSelectButton v-model="selectedTab" :options="notificationSections" />
            <Button 
                v-if="selectedTab === 'new'" 
                type="btn-outline-grey" 
                class=" d-flex gap-2 align-items-center justify-content-center" 
                @mouseover="iconHover = 'double-check'" 
                @mouseleave="iconHover = false"
                :disabled="!$store.getters['informator/unreadNotifications'].length"
                @click="markAllAsRead"
            >
                <Icon 
                    v-if="!isMobile" 
                    name="double-check" 
                    size="c20" 
                    :active="iconHover === 'double-check'" 
                />
                <span class="text-nowrap">{{ $t('components.service.Informator.1') }}</span>
            </Button>
            <Button 
                v-else 
                type="btn-outline-red" 
                class=" d-flex gap-2 align-items-center justify-content-center" 
                @mouseover="iconHover = 'trash'" 
                @mouseleave="iconHover = false"
                :disabled="!$store.getters['informator/readNotifications'].length"
                @click="deleteAllNotifications"
            >
                <Icon 
                    v-if="!isMobile" 
                    name="trash" 
                    size="c20" 
                    :active="iconHover === 'trash'" 
                />
                <span class="text-nowrap">{{ $t('components.service.Informator.2') }}</span>
            </Button>
        </div>
        <div v-if="notificationsListLength">
            <!-- Непрочитанные -->
            <div v-if="selectedTab === 'new'">
                <div v-for="notification in $store.getters['informator/unreadNotifications']" :key="notification.code" class="notification-item">
                    <div class="d-flex align-items-center gap-3">
                        <Icon :name="icons[notification.group]" size="c40" />
                        <div class="d-flex flex-column flex-grow-1 gap-1">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="fsp16 lh24 neue">{{ titles[notification.group] }}</div>
                                <div class="fsp12 lh16 text-nowrap fsp14 lh20 neue-roman">{{ getRelativeTime(notification.ts_create) }}</div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="fsp14 primary-grey lh20 neue-roman">{{ notification.message }}</div>
                                <Button 
                                    type="btn-outline-grey" 
                                    class="action-btn" 
                                    @mouseover="iconHover = `double-check-${notification.code}`" 
                                    @mouseleave="iconHover = false" @click="markAsRead(notification.code)"
                                >
                                    <Icon 
                                        v-if="!isMobile" 
                                        name="double-check" 
                                        size="c20" 
                                        :active="iconHover === `double-check-${notification.code}`" 
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Прочитанные -->
            <div v-else>
                <div v-for="notification in $store.getters['informator/readNotifications']" :key="notification.code" class="notification-item">
                    <div class="d-flex align-items-center gap-3">
                        <Icon :name="icons[notification.group]" size="c40" />
                        <div class="d-flex flex-column flex-grow-1 gap-1">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="fsp16 lh24 neue primary-grey">{{ titles[notification.group] }}</div>
                                <div class="fsp12 lh16 primary-grey text-nowrap fsp14 lh20 neue-roman">{{ getRelativeTime(notification.ts_create) }}</div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="fsp14 primary-grey lh20 neue-roman">{{ notification.message }}</div>
                                <Button 
                                    type="btn-outline-red" 
                                    class="action-btn" 
                                    @mouseover="iconHover = `trash-${notification.code}`" 
                                    @mouseleave="iconHover = false"
                                    @click="deleteNotification(notification.code)"
                                >
                                    <Icon 
                                        v-if="!isMobile" 
                                        name="trash" 
                                        size="c20" 
                                        :active="iconHover === `trash-${notification.code}`" 
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class='grey text-center background-empty h-100 d-flex align-items-center justify-content-center px16 flex-grow-1'>
            <div class="d-flex flex-column align-items-center">
                <div class="icon-background">
                    <Icon name="mail-check" size="c24" />
                </div>
                <h5 class="fsp20 lh28 mb-0 color-menu neue mb8">{{ $t('components.service.Informator.3') }}</h5>
                <div class="fsp14 lh20 primary-grey text-center neue-roman">
                    <div>{{ $t('components.service.Informator.4') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomSelectButton from './CustomSelectButton.vue';
import Icon from '@/components/icons/Icon';
import Button from './Button.vue';

export default {
    components: {
        CustomSelectButton,
        Icon,
        Button
    },
    data() {
        return {
            selectedTab: 'new',
            notificationSections: [
                { label: this.$t('components.service.Informator.5'), value: 'new', count: this.$store.getters['informator/unreadNotifications'].length },
                { label: this.$t('components.service.Informator.6'), value: 'archive', count: this.$store.getters['informator/readNotifications'].length }
            ],
            iconHover: false,
            notifications: [],
            icons: {
                'auth': 'inform-auth',
                'card': 'inform-card',
                'outcome': 'inform-outcome',
                'income': 'inform-income',
                'security ': 'inform-security',
                'mail': 'inform-mail',
                'payrequest': 'inform-payrequest',
            },
            titles: {
                'auth': this.$t('components.service.Informator.12'),
                'card': this.$t('components.service.Informator.13'),
                'outcome': this.$t('components.service.Informator.14'),
                'income': this.$t('components.service.Informator.15'),
                'security': this.$t('components.service.Informator.16'),
                'mail': this.$t('components.service.Informator.17'),
                'payrequest': this.$t('components.service.Informator.18')
            },
            currentTimestamp: Date.now(),
            updateTimerId: null,
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        notificationsListLength() {
            if(this.selectedTab === 'new') {
                return this.$store.getters['informator/unreadNotifications'].length;
            } else {
                return this.$store.getters['informator/readNotifications'].length;
            }
        }
    },
    mounted() {
        this.updateTimerId = setInterval(() => {
            this.currentTimestamp = Date.now();
        }, 60000); // обновляем каждую минуту
        this.$store.commit('SET_SHOW_NEW_NOTIFICATION', true);
    },
    beforeUnmount() {
        clearInterval(this.updateTimerId);
    },
    methods: {
        getRelativeTime(timestamp) {
            const now = this.currentTimestamp;
            const diff = now - timestamp;

            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);

            if (seconds < 60) {
                return this.$t('components.service.Informator.7');
            }

            if (minutes < 60) {
                return this.$t('components.service.Informator.8', { count: minutes });
            }

            if (hours < 24) {
                return this.$t('components.service.Informator.9', { count: hours });
            }

            if (days === 1) {
                return this.$t('components.service.Informator.10');
            }

            if (days < 7) {
                return this.$t('components.service.Informator.11', { count: days });
            }

            const date = new Date(timestamp);
            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }

            return `${day}.${month}.${year}`;
        },
        async markAsRead(code) {
            const res = await this.axios.post('ReadNotification', { data: { codes: [code] } });
            if (res.data.body.result == '0') {
                this.$store.dispatch('informator/markAsRead', code);
            }
        },
        async deleteNotification(code) {
            const res = await this.axios.post('DeleteNotification', { data: { codes: [code] } });
            if (res.data.body.result == '0') {
                this.$store.dispatch('informator/deleteNotification', code);
            }
        },
        async markAllAsRead() {
            const res = await this.axios.post('ReadNotification', { data: { codes: this.$store.getters['informator/unreadNotifications'].map(n => n.code) } });
            if (res.data.body.result == '0') {
                this.$store.dispatch('informator/markAllAsRead');
            }
        },
        async deleteAllNotifications() {
            const res = await this.axios.post('DeleteNotification', { data: { codes: this.$store.getters['informator/readNotifications'].map(n => n.code) } });
            if (res.data.body.result == '0') {
                this.$store.dispatch('informator/deleteAllReadNotifications');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.background-empty {
    background-image: url('@/assets/bg-empty-list.png');
    background-position: center;
}

.w32 {
    width: 32px;
}

.h32 {
    height: 32px;
}

.notification-item {
    padding: 12px 0;
    border-bottom: 1px solid $primary-stroke;

    &:hover .action-btn {
        visibility: visible;
        opacity: 1;
    }

    .action-btn {
        display: flex;
        visibility: hidden;
        opacity: 0;
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
    }
}
</style>